import { render, staticRenderFns } from "./CartaoBase.vue?vue&type=template&id=75938414&scoped=true"
import script from "./CartaoBase.vue?vue&type=script&lang=js"
export * from "./CartaoBase.vue?vue&type=script&lang=js"
import style0 from "./CartaoBase.vue?vue&type=style&index=0&id=75938414&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75938414",
  null
  
)

export default component.exports